export default __webpack_public_path__ + "static/mobile-ppq-modal-images-5e562e8fe235f5f22deb40d0c7d0b934.png";